import React from 'react';
import { HelpCircle, LifeBuoy, ShieldAlert } from 'lucide-react';
import { HELP_CENTER_URL, securityMailto, supportMailto } from '../../utils/support';

interface SupportLinksProps {
  /** Collapsed sidebar: icons only */
  compact?: boolean;
}

const linkClass = 'flex items-center gap-2 rounded-lg px-4 py-2 text-sm text-gray-300 hover:bg-slate-700 hover:text-gray-100';

/** Help center, Contact support and Report a security concern (Phase 14, SUP-04/05, §8.5). No PHI. */
const SupportLinks: React.FC<SupportLinksProps> = ({ compact = false }) => {
  if (compact) {
    return (
      <div className="flex flex-col items-center space-y-3" data-testid="support-links">
        <a href={HELP_CENTER_URL} target="_blank" rel="noopener noreferrer" title="Help center" aria-label="Help center" className="text-gray-300 hover:text-gray-100"><HelpCircle size={20} /></a>
        <a href={supportMailto()} title="Contact support" aria-label="Contact support" className="text-gray-300 hover:text-gray-100"><LifeBuoy size={20} /></a>
        <a href={securityMailto()} title="Report a security concern" aria-label="Report a security concern" className="text-gray-300 hover:text-gray-100"><ShieldAlert size={20} /></a>
      </div>
    );
  }
  return (
    <nav aria-label="Support" className="space-y-1" data-testid="support-links">
      <a href={HELP_CENTER_URL} target="_blank" rel="noopener noreferrer" className={linkClass}><HelpCircle size={18} aria-hidden="true" /> Help center</a>
      <a href={supportMailto()} className={linkClass}><LifeBuoy size={18} aria-hidden="true" /> Contact support</a>
      <a href={securityMailto()} className={linkClass}><ShieldAlert size={18} aria-hidden="true" /> Report a security concern</a>
    </nav>
  );
};

export default SupportLinks;
